/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/jobs/:job_id/sink_logs" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiJobsJobIdSinkLogs } from "./constants";
import type { IntegrationsDirectCdiJobsJobIdSinkLogsParams, SinkLogsResult } from "./types";
import { isSinkLogsResult } from "./validators";

export const getCdiJobsSinkLogs = reactQueryTableFetcherAdapter(
  integrationsDirectCdiJobsJobIdSinkLogs,
  (
    signal: AbortSignal,
    {
      jobId,
      logType,
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: IntegrationsDirectCdiJobsJobIdSinkLogsParams
  ): Promise<SinkLogsResult> => {
    return fetch(
      `/integrations/direct/cdi/jobs/${jobId}/sink_logs`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
        log_type: logType,
      },
      { signal }
    );
  },
  isSinkLogsResult
);
